import { configureStore } from "@reduxjs/toolkit";
// settings
import settings from "../features/settings/Slice";

// auth
import auth from "../features/auth/Slice";

// common
import common from "../features/admin/common/Slice";

// Customer
import customer from "./customer";

// customization
import customization from "./customization";

// Dashboard
import dashboard from "./dashboard";

// host;
import host from "./host";

// recording_list;
import recording_list from "./recording_list";

// notification;
import notification from "./notification";

// attendence;
import attendence from "./attendence";

import all_recording from "./all_recording";

import appsetup from "./appsetup";

export const store = configureStore({
  reducer: {
    // settings
    settings: settings,

    //auth
    auth: auth,

    //common
    common: common,

    //Customer
    customer,

    //customization
    customization,

    // dashboard
    dashboard,

    // host
    host,

    // recording_list
    recording_list,

    // notification
    notification,

    //  attendence,
    attendence,

    all_recording,

    appsetup,
  },
});
